<template>
    <div class="hover-border hover-pointer" @click.self="open_edit_menu">

    <div class="or-admin-product-constructor-image hover-border" @click.self="open_edit_menu">
        <div class="images" :style="[options.style, 'display: flex']" @click.self="open_edit_menu">
            <p class="image-text" v-show="options.images.length === 0" @click.self="open_edit_menu">Загрузите изображение...</p>
            <img :src="img.src" class="image hover-pointer hover-border-out" @click="edit_image(img.style)" :style="img.style" v-for="img in options.images" :key="img.id"/>
        </div>
    </div>

    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    props: {
        options: Object,
    },
    data() {
        return {
            show_icon: false,
            show_edit: false,
            show_image_edit: false,
            editable_image_style: null,
            image_style_titles: {
                width: 'Ширина изображения (%, px)',
                height: 'Высота изображения (%, px)',
                paddingTop: 'Отступ сверху (%, px)',
                marginLeft: 'Отступ слева (%, px)',
                marginRight: 'Отступ справа (%, px)',
                marginBottom: 'Отступ снизу (%, px)',
                objectFit: 'Режим заполнения рамки изображением',
                objectPosition: 'Расположение изображения внутри рамки',
            },
            image_style_options: {
                objectFit: [
                    'fill',
                    'cover',
                    'contain',
                    'none',
                ],
                objectPosition: [
                    'center',
                    'left',
                    'right',
                    'top',
                    'bottom',
                    'left top',
                    'left bottom',
                    'right top',
                    'right bottom',
                ],
            },
            style_titles: {
                height: 'Высота блока (px)',
                paddingTop: 'Отступ сверху (%, px)',
                marginLeft: 'Отступ слева (%, px)',
                marginRight: 'Отступ справа (%, px)',
                marginBottom: 'Отступ снизу (%, px)',
                justifyContent: 'Выравнивание вдоль направления картинок внутри блока',
                alignItems: 'Выравнивание поперёк направления картинок внутри блока',
                flexWrap: 'Перенос картинок на следующую строку',
                flexDirection: 'Направление картинок внутри блока',
                minHeight: 'Минимальная высота блока (px)',
            },
            style_options: {
                flexDirection: [
                    'row',
                    'column',
                ],
                flexWrap: [
                    'wrap',
                    'nowrap'
                ],
                justifyContent: [
                    'space-around',
                    'space-between',
                    'flex-start',
                    'flex-end',
                    'center'
                ],
                alignItems: [
                    'center',
                    'flex-start',
                    'flex-end',
                ],
            }
        }
    },
    computed: {
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.options.value, container: div});
            return div.innerHTML;
        }
    },
    methods: {
        ...mapActions({convertText: 'convertText',
            addUnsavedPage: 'addUnsavedPage',
            changeAdmin: 'changeAdmin'}),
        open_edit_menu(e) {
            this.changeAdmin({property: 'edit_menu', value: {show: true, left: e.pageX + 'px', top: e.pageY + 'px', this_ctx: this}})
        },
        delete_item() {
            this.$emit('delete_item');
            this.addUnsavedPage({page: 'products'})
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
        },
        move_up() {
            this.$emit('move_up');
            this.addUnsavedPage({page: 'products'})
        },
        move_down() {
            this.$emit('move_down');
            this.addUnsavedPage({page: 'products'})
        },
        open_edit() {
            this.changeAdmin({property: 'type', value: 'image'});
            this.changeAdmin({property: 'edit_this', value: this});
            this.changeAdmin({property: 'show_edit', value: true});
            this.changeAdmin({property: 'show_image_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            this.editable_image_style = null;
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
        },
        close_edit() {
            this.changeAdmin({property: 'type', value: null});
            this.changeAdmin({property: 'edit_this', value: null});
            this.changeAdmin({property: 'show_edit', value: false});
            this.changeAdmin({property: 'show_image_edit', value: false});

        },
        edit_image(style) {
            this.changeAdmin({property: 'type', value: 'image'});
            this.changeAdmin({property: 'edit_this', value: this});
            this.changeAdmin({property: 'show_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            this.changeAdmin({property: 'show_image_edit', value: true});
            this.editable_image_style = style;
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
        },
        delete_img(i) {
            this.options.images.splice(i, 1);
            this.addUnsavedPage({page: 'products'})
        },
        up_img(i) {
            if (i === this.options.images.length - 1) return;
            const img = this.options.images.splice(i, 1)[0];
            this.options.images.splice(i + 1, 0, img);
            this.addUnsavedPage({page: 'products'})
        },
        down_img(i) {
            if (i === 0) return;
            const img = this.options.images.splice(i, 1)[0];
            this.options.images.splice(i - 1, 0, img);
            this.addUnsavedPage({page: 'products'})
        },
        async getFile(file) {
            // const file = this.$refs.file.files[0];
            await this._convertToBase64(file);
            this.addUnsavedPage({page: 'products'})
        },
        _convertToBase64(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const image = JSON.parse(JSON.stringify(this.options.image_default));
                image.id = this.options.images.length + 1;
                image.src = reader.result;
                this.options.images.push(image);
            }
        },
    }
}
</script>

<style scoped>
    .or-admin-product-constructor-image {
        position: relative;
    }
    .edit-icon {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 20px;
        height: 20px;
    }
    .edit {
        position: relative;
        width: 100%;    
        bottom: 0px;
        min-height: 100px;
        box-sizing: border-box;
        padding: 30px;
        background-color: white;
        color: black;
        border-radius: 0 0 8px 8px;
        font-size: 14px;
        line-height: 16px;
        z-index: 999999;
    }
    .input-container {
        margin-bottom: 20px;
    }
    .text {
        text-align: left;
        margin-left: 17px;
        margin-bottom: 5px;
    }
    .input {
        padding: 0 15px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        border-radius: 8px;
        border: gray 1px solid;
        outline: none;
    }
    .select {
        padding: 0 15px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        border-radius: 8px;
        border: gray 1px solid;
        outline: none;
    }
    .direction {
        position: absolute;
        top: 15px;
        width: 20px;
        height: 20px;
    }
    .up-icon {
        right: 45px;
    }
    .down-icon {
        right: 75px;
    }
    .remove-icon {
        right: 105px;
    }
    .image-text {
        font-size: 14px;
        line-height: 16px;
    }
</style>